import { render, staticRenderFns } from "./MessageCard.vue?vue&type=template&id=1f6982be&scoped=true"
import script from "./MessageCard.vue?vue&type=script&lang=js"
export * from "./MessageCard.vue?vue&type=script&lang=js"
import style0 from "./MessageCard.vue?vue&type=style&index=0&id=1f6982be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6982be",
  null
  
)

export default component.exports